export default __webpack_public_path__ + "img/4edd5b2e303643833df57fd938e8bb9b.mp3";